/*  ========================================================================
    # Scripts - Header Menu Mobile
    ========================================================================  */

const HeaderMenuMobile = {
  cfg: {
    header: document.querySelector('.c-header'),
    button: document.querySelector('.c-header__burger'),
    menu: document.querySelector('.c-header-menu-mobile'),
    menuContent: document.querySelector('.c-header-menu-mobile__content'),
    menuEntries: document.querySelectorAll('.c-header-menu-mobile__entry'),
    background: document.querySelector('.c-header-menu-mobile__background'),
    classes: {
      burgerActive: 'c-header__burger--active',
      menuActive: 'c-header-menu-mobile--active',
      entryExpandCollapse: 'c-header-menu-mobile__entry-expand-collapse',
      entryActive: 'c-header-menu-mobile__entry--active',
      submenu: 'c-header-menu-mobile__submenu'
    },
    transitionDuration: 200
  },

  /**
   * Set Top spacing.
   */
  setTopSpacing() {
    this.cfg.menu.style.top = `${this.cfg.header.offsetHeight - 2}px`;

    window.addEventListener('resize', () => {
      this.cfg.menu.style.top = `${this.cfg.header.offsetHeight - 2}px`;
    });
  },

  /**
   * Show/hide the mobile menu.
   */
  handlerShowHide() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    } else {
      document.body.style.overflow = 'hidden';
    }
    this.cfg.button.classList.toggle(this.cfg.classes.burgerActive);
    this.cfg.menu.classList.toggle(this.cfg.classes.menuActive);
  },

  /**
   * Set the corresponding height for every submenu.
   *
   * @param {Object} submenu
   * @param {string} submenuHeight
   * @param {string} action
   */
  setHeightSubmenu(submenu, submenuHeight, action) {
    // Init
    if (action === 'init') {
      submenu.style.height = '0px';
    }

    // Show
    if (action === 'show') {
      submenu.style.height = submenuHeight;
      setTimeout(() => {
        submenu.style.height = 'auto';
      }, this.cfg.transitionDuration);
    }

    // Hide
    if (action === 'hide') {
      submenu.style.height = submenuHeight;
      setTimeout(() => {
        submenu.style.height = '0px';
      }, 10);
    }
  },

  /**
   * Show/hide submenus.
   */
  handlerSubmenus() {
    this.cfg.menuEntries.forEach(entry => {
      const submenu = entry.querySelector(`.${this.cfg.classes.submenu}`);

      if (submenu) {
        let submenuHeight = `${submenu.offsetHeight}px`;

        // Init Height
        this.setHeightSubmenu(submenu, submenuHeight, 'init');

        // Resize Height
        window.addEventListener('resize', () => {
          if (entry.classList.contains(this.cfg.classes.active)) {
            submenuHeight = `${submenu.offsetHeight}px`;
          } else {
            submenu.style.height = 'auto';
            submenuHeight = `${submenu.offsetHeight}px`;
            submenu.style.height = '0px';
          }
        });

        // Open & Close
        entry
          .querySelector(`.${this.cfg.classes.entryExpandCollapse}`)
          .addEventListener('click', () => {
            if (entry.classList.contains(this.cfg.classes.entryActive)) {
              entry.classList.remove(this.cfg.classes.entryActive);
              this.setHeightSubmenu(submenu, submenuHeight, 'hide');
            } else {
              entry.classList.add(this.cfg.classes.entryActive);
              this.setHeightSubmenu(submenu, submenuHeight, 'show');
            }
          });
      }
    });
  },

  /**
   * Initialize.
   */
  init() {
    this.setTopSpacing();

    this.cfg.button.addEventListener('click', () => {
      this.handlerShowHide();
    });

    this.cfg.background.addEventListener('click', () => {
      this.handlerShowHide();
    });

    this.handlerSubmenus();
  }
};

export default HeaderMenuMobile;
